import { Component, ElementRef, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrderMarketTypeEnum } from '@toro/common/shared/enum/orders/market-type.enum';
import { OrderSideEnum } from '@toro/common/shared/enum/orders/side.enum';
import { DialogFullScreenComponentContent } from '@toro/common/shared/models/dialogs/dialog-full-screen';

@Component({
    selector: 'dialog-graphic',
    templateUrl: './dialog-graphic.component.html',
    styleUrls: ['../common/dialog-right.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class TrackingChartDialogComponent extends DialogFullScreenComponentContent implements OnInit {

    public asset: string;
    public gainPrice: number;
    public lossPrice: number;
    public typeMarket: OrderMarketTypeEnum;
    public side: OrderSideEnum;
    public stopGainLabel: string;
    public stopLossLabel: string

    constructor(
        private dialogReference : MatDialogRef<TrackingChartDialogComponent>, 
        element : ElementRef,
        @Inject(MAT_DIALOG_DATA) public data : { 
            gainPrice: number, 
            lossPrice: number, 
            asset: string, 
            typeMarket: OrderMarketTypeEnum, 
            side: OrderSideEnum,
            stopLossLabel: string,
            stopGainLabel: string
        }
    ) {

        super(element);

        this.asset = data.asset;
        this.gainPrice = data.gainPrice;
        this.lossPrice = data.lossPrice;
        this.typeMarket = data.typeMarket;
        this.side = data.side;
        this.stopLossLabel = data.stopLossLabel;
        this.stopGainLabel = data.stopGainLabel;
    }

    /** Finaliza o componente */
    dispose(){
        super.close(this.dialogReference, null);
    }

    onGainHitHandler(event){

    }

    onStopHitHandler(event){

    }

    setStopGainLabel(value: string){
        this.stopGainLabel = value;
    }
}